import { useTranslation } from "react-i18next";

export const WhatsAroundUs = () => {
    const { t } = useTranslation("about");

    return (
        <div className="max-w-5xl text-lg bg-card p-4 rounded-md shadow-xl ">
            <div className="flex flex-col justify-center items-center">
                <h2 className="text-2xl font-bold text-center uppercase text-gray-700">{t("aboutPage.whatsAroundUs.title")}</h2>
                <div className="w-[280px] mb-4 border-2  border-b-[#bb9f82] " />
            </div>

            <p className="mb-4">
                {t("aboutPage.whatsAroundUs.description")}
            </p>

            <div className="ml-8">
                <ul className="list-disc">
                    {t("aboutPage.whatsAroundUs.details", { returnObjects: true }).map((item, index) => (
                        <li key={index}>
                            <strong>{item.label}</strong>: {item.value}
                        </li>))
                    }
                </ul>
            </div>
        </div>
    )
}